import { render, staticRenderFns } from "./automations.vue?vue&type=template&id=0fa78a2a&scoped=true"
import script from "./automations.vue?vue&type=script&lang=js"
export * from "./automations.vue?vue&type=script&lang=js"
import style0 from "./automations.vue?vue&type=style&index=0&id=0fa78a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa78a2a",
  null
  
)

export default component.exports